<div class="outer-container-final">
    <mat-toolbar color="primary" class="toolbar-final">
        <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo" />
        <div class="toolbar-inner-final">High Limits Disability Insurance Application</div>
    </mat-toolbar>
    <div class="main-final">
    
        <div class="main-inner-final">
            <h3 class="final-page">Thank You for Your Application</h3>
            <div class="body-text-final">
                We have received your application and sent you a confirmation email summarizing your requested coverage details 
                available to you as a member of <strong>{{ this.opportunityName }}</strong>.
            </div>
        </div>
        <br />
        <div class="main-inner-final">
            <div class="title-final">Payment</div>
            <div class="body-text-final">
                We only process payments after we have approved your application and bound coverage.  If we don't approve your application, we'll notify you and cancel any pending transactions.
                </div>
        </div>
        <br />
        <div class="main-inner-final">
            <div class="title-final">Next Steps</div>
            <div class="body-text-final">
                Our underwriting team will review your application and respond within three businses days.  We look forward to working with you.
            </div>
        </div>
        <div class="button-area-final">
            <button class="button-mgis" class="chat-button chat-button-define" mat-flat-button (click)="gotoLanding()">Done</button>
        </div>
    </div>
</div>
